// extracted by mini-css-extract-plugin
export var speaker = "speaker-module--speaker--b9142";
export var speaker__descName = "speaker-module--speaker__desc-name--84096";
export var speaker__descProf = "speaker-module--speaker__desc-prof--6da84";
export var speaker__descWrapper = "speaker-module--speaker__desc-wrapper--cfd51";
export var speaker__imageBlock = "speaker-module--speaker__image-block--4cfbe";
export var speaker__list = "speaker-module--speaker__list--6bf55";
export var speaker__row = "speaker-module--speaker__row--3bde0";
export var speaker__title = "speaker-module--speaker__title--22e36";